/**
 * The offer for service businesses. Every page that states the price reads from here so the
 * home page, signup and pricing card never disagree.
 */
export const PRO_MONTHLY_PRICE = '$50';

/** One-line offer, e.g. for badges and the home page band. */
export const PRO_OFFER_SUMMARY = 'Ask about our signup offer';
